import React from 'react';
import PropTypes from 'prop-types';
import { Beforeunload } from 'react-beforeunload';
import { Prompt } from 'react-router-dom';

const BeforeUnload = ({ dirty, message }) => {
  return (
    <>
      {dirty && <Beforeunload onBeforeunload={() => message} />}
      <Prompt when={dirty} message={() => message} />
    </>
  );
};

BeforeUnload.defaultProps = {
  dirty: false,
  message: 'If you leave before saving, your changes will be lost.',
};

BeforeUnload.propTypes = {
  dirty: PropTypes.bool,
  message: PropTypes.string,
};

export default BeforeUnload;
